import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { Auth } from './api';

interface AuthState {
  authenticated: boolean;
  loading: boolean;
  login: (password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthState | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Auth.me().then((r) => setAuthenticated(r.authenticated)).catch(() => setAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (password: string) => {
    await Auth.login(password);
    setAuthenticated(true);
  };
  const logout = async () => {
    await Auth.logout();
    setAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ authenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth precisa estar dentro de AuthProvider');
  return ctx;
}
